import { Component, Input } from "@angular/core";

@Component({
    selector: "web-brand-logo",
    templateUrl: "./brand-logo.component.html",
    styleUrls: ["./brand-logo.component.scss"],
})
export class BrandLogoComponent {
    @Input() brandLogoWhite: boolean = false;
}
